"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useState } from "react";

export function QueryProvider({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            // Data considered fresh for 60 seconds
            staleTime: 60 * 1000,
            // Garbage collect unused data after 5 minutes
            gcTime: 5 * 60 * 1000,
            // Don't refetch on window focus in development (annoying during dev)
            refetchOnWindowFocus: process.env.NODE_ENV === "production",
            // Retry failed requests
            retry: 1,
            // Refetch on mount if data is stale
            refetchOnMount: true,
          },
          mutations: {
            // Retry failed mutations once
            retry: 1,
          },
        },
      })
  );

  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
}
